module.exports = __webpack_public_path__ + "static/media/ico1.a0df8f87.png";